import React from 'react';
import { Card, CardContent, Typography, Box, Button, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { CampaignStatus } from '../../types/Campaign';

interface DashboardOverviewProps {
  id: string;
  name: string;
  description: string;
  organizationName: string;
  organizationId: string;
}

const DashboardOverview: React.FC<DashboardOverviewProps> = ({ id, name, description, organizationName, organizationId }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    // Route campaigns in Matching mode directly to ApplicationDashboard
    if (status === CampaignStatus.MATCHING) {
      navigate(`/organizations/${organizationId}/campaigns/${id}/matching/application-dashboard`);
    } else {
      navigate(`/organizations/${organizationId}/campaigns/${id}`);
    }
  };

  const displayName = name || 'Unnamed Campaign';
  const status = description.includes('Status:') ? description.split('Status: ')[1] : '';

  // Determine color based on status
  const getStatusColor = () => {
    switch (status) {
      case CampaignStatus.PREP:
        return 'info';
      case CampaignStatus.MATCHING:
        return 'warning';
      case CampaignStatus.RUNNING:
        return 'success';
      case CampaignStatus.CLOSED:
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Card
      sx={{
        boxShadow: 3,
        borderRadius: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
        }
      }}
    >
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Box mb={1}>
          <Chip
            label={status}
            size="small"
            color={getStatusColor()}
            sx={{ fontWeight: 'bold' }}
          />
        </Box>
        <Box mb={1}>
          <Chip
            label={organizationName}
            size="small"
            variant="outlined"
            sx={{ fontSize: '0.75rem' }}
          />
        </Box>

        <Typography variant="h6" gutterBottom>
          {displayName}
        </Typography>

        <Box mt="auto" display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleEditClick}>
            MANAGE
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DashboardOverview;
